import { CTooltip } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarTooltip = (props) => {
  const { children, content } = props
  return (
    <CTooltip placement={'top'} content={content}>
      {children}
    </CTooltip>
  )
}

export { ConfiaCarTooltip }
